import React, { useState } from "react";
//import { useRef } from "react";
import Question from "../components/Form/Question";
//import FormData from "../components/Form/QD.json";
import { AddReport } from "../Requests";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import GetAge from "../Utils/GetAge";

const ProfileForm = (props) => {
  //const inputRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [inputs, setInputs] = useState({});
  const [open, setOpen] = useState(false);
  const [canSubmit, setSubmit] = useState(true);
  // const closeModal = () => setOpen(false);
  //  const [showQuestion, setShowQuestion] = useState(buildShownObject(false));
  // console.log("props.QDB :>> ", props.QDB);
  let FormData = props.QDB.sort(
    (a, b) => parseInt(a.Order) - parseInt(b.Order)
  );
  const logging = false;
  const pageArr = [
    { label: "Let's talk about you", count: 0 },
    { label: "Let's talk about your living situation", count: 0 },
    { label: "Let's talk about your household income", count: 0 },
    {
      label: "Let's talk about your household financial assets",
      count: 0,
      marriedLabel:
        "Include any financial assets for your spouse/partner when applicable",
    },
    {
      label: "Let's talk about your household investment assets",
      count: 0,
      marriedLabel:
        "Include any investment assets for your spouse/partner when applicable",
    },
    { label: "Let's talk about your life insurance", count: 0 },
    { label: "Let's talk about your disability income insurance", count: 0 },
    { label: "Let's talk about your long-term care insurance", count: 0 },
    { label: "Let's talk about your homeowner's insurance", count: 0 },
    { label: "Let's talk about your renter's insurance", count: 0 },
    { label: "Let's talk about your vehicle and auto insurance", count: 0 },
    { label: "Let's talk about your personal liability insurance", count: 0 },
    {
      label: "Let's talk about your household debt",
      count: 0,
      marriedLabel: "Include any debt for your spouse/partner when applicable",
    },
    { label: "Let's talk about your household monthly expenses", count: 0 },
    { label: "Let's talk about your estate plan", count: 0 },
    { label: "Let's talk about your social security", count: 0 },
    { label: "Let's talk about your financial goals", count: 0 },
  ];

  const [page, setPage] = useState(0);
  function setSpecificInput(name, value, type) {
    if (inputs[name] === undefined) {
      inputs[name] = {};
      //   inputs[name] = { val: 0, valType: type };
      //   console.log(name, inputs[name].val);
    }
    if (inputs[name].val !== value || inputs[name].val === undefined) {
      if (logging === true) {
        // console.log(`N:${name} V: ${value} Type: ${type}`);
      }
      setInputs((values) => ({
        ...values,
        [name]: { val: value, valType: type },
      }));
    }

    localStorage.setItem(props.getIName(), JSON.stringify(inputs));
    // logging === true
    //   ? console.log("storing objects in local storage >> ", name)
    //   : doNothing();
    // console.log("inputs", JSON.stringify(localStorage.getItem("inputs")));
  }

  function canShowSubmit() {
    countQuestionsOnPage();
    for (let i = page + 1; i < pageArr.length; i++) {
      const element = pageArr[i];
      //  console.log("element.count :>> ", element.count);
      if (element.count > 0) {
        return false;
      }
    }
    return true;
  }

  //console.log("Profile Form Inputs:", inputs);
  const handleValue = (event) => {
    //checkAge();
    const name = event.target.id;
    const value = event.target.value.replaceAll(",", "");
    const iType = event.target.type;
    if (iType === "radio") {
      setSpecificInput(name, event.target.checked, iType);
    } else {
      setSpecificInput(name, value, iType);
    }
    // if (name.includes("Child")) {
    // console.log("Child Related Question!");
    checkChildrenAge();
    // }
  };
  // function checkAge() {
  //   setSpecificInput("Age", parseInt(props.activeProfile.Age), "number");
  // }
  function checkChildrenAge() {
    var youngest = 120;
    var current;

    for (var i = 0; i < 10; i++) {
      if (
        inputs[`Child_${i}_DoB_1`] === undefined ||
        inputs[`Child_${i}_DoB_2`] === undefined ||
        inputs[`Child_${i}_DoB_3`] === undefined
      ) {
        current = 120;
      } else {
        const today = new Date();

        const yyyy = parseInt(today.getFullYear());
        let mm = parseInt(today.getMonth()) + 1; // Months start at 0!
        let dd = parseInt(today.getDate());
        let DOBmm = parseInt(inputs[`Child_${i}_DoB_1`].val);
        let DOBdd = parseInt(inputs[`Child_${i}_DoB_2`].val);
        let DOByyyy = parseInt(inputs[`Child_${i}_DoB_3`].val);
        //        console.log("typeOf(DOBdd) :>> ", typeof DOBdd);
        current = 0;
        if (logging === true) {
          console.log("today", `${mm},${dd},${yyyy}`);
        }
        if (logging === true) {
          console.log("DOB", `${DOBmm},${DOBdd},${DOByyyy}`);
        }
        setSpecificInput(`Child_${i}_Age`, current, "number");
        current = GetAge(DOBdd, DOBmm, DOByyyy);
        if (logging === true) console.log("current Age :>> ", current);

        if (current < youngest) {
          youngest = current;
        }
      }
      if (logging === true) console.log("youngest :>> ", youngest);
    }
    if (inputs["Age"] === undefined)
      setSpecificInput("Age", props.activeProfile.Age, "number");
    setSpecificInput(
      "has_minor_children",
      youngest < 18 ? "Yes" : "No",
      "radio"
    );
    setSpecificInput(
      "has_children_under_16",
      youngest < 16 ? "Yes" : "No",
      "radio"
    );
    setSpecificInput("age_youngest", youngest, "number");
  }

  function getQfromNumber(qNumber) {
    var strNum = String(qNumber);
    var returnValue = FormData.find((obj) => {
      return obj["New_#"] === strNum;
    });

    //console.log(`number ${qNumber}: ${JSON.stringify(returnValue)}`);
    if (returnValue) {
      return returnValue;
    } else {
      return "undefined";
    }
  }

  function getAnswer(qNumber, qIndex, altDefault = "") {
    var q = getQfromNumber(qNumber);
    var QuestionID = q.Code_ID;
    if (QuestionID === undefined) {
      if (inputs[qNumber] === undefined) {
        return altDefault;
      }
      // console.log(qNumber, inputs[qNumber].val);
      if (inputs[qNumber].val === undefined) {
        return altDefault;
      }
      if (inputs[qNumber].val.includes(".")) {
        return parseFloat(inputs[qNumber].val);
      }
      return inputs[qNumber].val;
    }

    if (QuestionID.includes("_X") && qIndex > 0) {
      QuestionID += `_${qIndex}`;
    }

    if (inputs[QuestionID]) {
      //console.log(`Answer ${inputs[QID].val} Found for Question ${QID}`);
      if (inputs[QuestionID].val !== undefined) {
        let answer = inputs[QuestionID].val;
        // console.log("GetAnswer:", QuestionID, inputs[QuestionID].val);
        // console.log(answer, typeof answer);
        //        if (answer.includes(".")) answer = parseFloat(answer);
        return answer;
      }
    }
    //console.log(`no answer for Q:${QID}`);
    return q.default_value;
    /*if (qNumber === "4A") return "Own";
    if (qNumber === "4C") return 5;
    return "Yes";*/
  }

  function shouldHide(questionObject, inloop = false) {
    if (questionObject === undefined) {
      return true;
    }
    function parseCond(conditionText) {
      var splitCond;
      if (conditionText === "always") {
        return false;
      }
      if (conditionText === "never") {
        return true;
      }
      if (conditionText.includes(">")) {
        splitCond = conditionText.split(">");
        if (inputs[getQfromNumber(splitCond[0]).Code_ID]) {
          return getAnswer(splitCond[0]) <= splitCond[1];
        }
        return true;
      }
      if (conditionText.includes(":")) {
        splitCond = conditionText.split(":");

        if (inputs[getQfromNumber(splitCond[0]).Code_ID]) {
          return getAnswer(splitCond[0]) !== splitCond[1];
        }
        return true;
      }
      if (conditionText.includes("<")) {
        splitCond = conditionText.split("<");
        if (inputs[getQfromNumber(splitCond[0]).Code_ID])
          return getAnswer(splitCond[0]) >= splitCond[1];
        return true;
      }
      return false;
    }

    if (inloop === false && questionObject.Code_ID.includes("_X")) {
      return true;
    }
    var conditionArr = questionObject.revealed_if.split("/");
    var conditionArrAnd = questionObject.revealed_if.split("&&");

    if (questionObject.revealed_if.includes("&&")) {
      /*if (questionObject["New_#"] === "13B") {
        console.log(questionObject.revealed_if);
        console.log(getQfromNumber("6B"));
        console.log(getAnswer("6B", 0));
      }*/

      for (var i = 0; i < conditionArrAnd.length; i++) {
        if (inloop === false && questionObject.Code_ID.includes("_X")) {
          return true;
        }
        let currentlyChecked = parseCond(conditionArrAnd[i]);
        if (currentlyChecked === true) {
          return true;
        }
      }
      return false;
    }
    if (questionObject.revealed_if.includes("/")) {
      for (let i = 0; i < conditionArr.length; i++) {
        if (inloop === false && questionObject.Code_ID.includes("_X")) {
          return true;
        }
        let currentlyChecked = parseCond(conditionArr[i]);
        if (currentlyChecked === false) {
          return false;
        }
      }
      return true;
    }
    return parseCond(questionObject.revealed_if);
  }
  function doNothing() {}

  function countQuestionsOnPage() {
    for (let i = 0; i < pageArr.length; i++) {
      //loops through all the pages
      pageArr[i].count = 0; //Sets the question count to 0
    }

    for (let questionNum = 0; questionNum < FormData.length; questionNum++) {
      //loops through all the pages again
      const question = FormData[questionNum];
      const qPage = pageArr.findIndex(
        (element) => element.label === question.page
      ); //finds the Question ID for each of them that is on X page and stores it in qPage
      if (shouldHide(question) === false) {
        //IF the question should be hidden based on the answers, it is not added to the page count.
        qPage >= 0 ? (pageArr[qPage].count += 1) : doNothing(); //Modify the page array to have an accurate count
      }
    }
  }

  function prevHandler() {
    if (page !== 0) {
      countQuestionsOnPage();
      for (let i = page - 1; i >= 0; i--) {
        if (pageArr[i].count > 0) {
          setPage(i);
          break;
        }
      }
    }
    //console.log("clicked prev");
  }

  // const accessiblePages = [];

  // function updateAccessibles() {
  //   accessiblePages.length = 0;
  //   countQuestionsOnPage();
  //   for (let i = 0; i <= pageArr.length - 1; i++) {
  //     if (pageArr[i].count > 0) {
  //       accessiblePages.push(pageArr[i]);
  //     }
  //   }
  // }

  function goPage(event, pageToSet) {
    event.preventDefault();
    // console.log("clicked on gotopage");
    if (pageToSet === 0) {
      setPage(pageToSet);
      return;
    }

    countQuestionsOnPage();
    for (let i = pageToSet; i >= 0; i--) {
      if (i > pageArr.length) continue;
      if (pageArr[i].count === 0) continue;
      setPage(i);
      break;
    }
  }

  function nextHandler() {
    if (page !== pageArr.length - 1) {
      countQuestionsOnPage();
      for (let i = page + 1; i <= pageArr.length - 1; i++) {
        if (pageArr[i].count > 0) {
          setPage(i);
          break;
        }
      }
    }
    // console.log("clicked next");
  }

  function submitHandler(event) {
    event.preventDefault();

    setOpen(true);
    setSubmit(false);
    //    localStorage.removeItem(props.getIName());
    localStorage.setItem(props.getIName(), JSON.stringify(inputs));
    AddReport(
      inputs,
      props.userKey,
      props.activeProfile,
      props.profileData,
      props.Dev
    );
  }

  if (isLoading) {
    //console.log(props.prevInput);
    setInputs(props.prevInput);
    setIsLoading(false);
  } else {
    let count = 0;
    // updateAccessibles();
    //console.log(showQuestion);
    return (
      <div id="form_container">
        <ul>
          <form id="profileForm" className="appnitro" onSubmit={submitHandler}>
            <div className="form_description ">
              <h1>Profile </h1>
              <h3>{pageArr[page].label}.</h3>
              <h4>
                {/* {inputs.Marital_Status === undefined
                  ? ""
                  : inputs.Marital_Status.val === "Married"
                  ? pageArr[page].marriedLabel === undefined
                    ? ""
                    : pageArr[page].marriedLabel + "."
                  : ""} */}
              </h4>
            </div>
            {FormData.map((question) => {
              // if (question.Code_ID === "count_ss_benefit") {
              //   console.log(question.Code_ID, shouldHide(question));
              // }
              if (shouldHide(question)) {
                return <div key={question["New_#"]}></div>;
              }
              if (pageArr[page].label !== question.page) {
                return <div key={question["New_#"]}></div>;
              }
              // console.log(
              //   question["New_#"],
              //   JSON.stringify(shouldHide[question])
              // );
              count += 1;
              // console.log(
              //   question.Code_ID,
              //   question["New_#"],
              //   shouldHide(question)
              // );
              if (inputs[question.Code_ID] === undefined) {
                // console.log(
                //   "New undef Input",
                //   `N:${question.Code_ID} V:${question.default_value}`
                // );
                setSpecificInput(
                  question.Code_ID,
                  question.default_value,
                  question.Question_Type
                );
              }
              return (
                <div key={question["New_#"]}>
                  {props.Dev ? `${count}: Q${question["New_#"]}` : <></>}
                  <Question
                    Question={question}
                    QID={question.Code_ID}
                    handleValue={handleValue}
                    getq={getQfromNumber}
                    getAnswer={getAnswer}
                    sh={shouldHide}
                    Dev={props.Dev}
                    QDB={FormData}
                    getIName={props.getIName}
                  />
                </div>
              );
            })}
            {props.Dev ? (
              <div id="logButton">
                <button onClick={(event) => goPage(event, 0)}>
                  First Page
                </button>
                <button onClick={(event) => goPage(event, pageArr.length - 1)}>
                  Last Page
                </button>
                <button onClick={(event) => submitHandler(event)}>
                  Submit
                </button>
                <button onClick={(event) => logInputs(event)}>Log</button>
              </div>
            ) : (
              <></>
            )}
            <div className="formControls">
              <a
                href="#top"
                className={
                  page === 0 ? "divButton disabledButton" : "divButton hoverBox"
                }
                onClick={() => {
                  prevHandler();
                }}
              >
                Prev
              </a>
              <div
                className={
                  /*
                  page !== pageArr.length - 1 || */ canShowSubmit() === false ||
                  canSubmit === false
                    ? "divButton disabledButton"
                    : "divButton hoverBox"
                }
                onClick={(event) => submitHandler(event)}
              >
                Submit
              </div>

              <a
                href="#top"
                className={
                  // page === pageArr.length - 1
                  canShowSubmit() === true
                    ? "divButton disabledButton"
                    : "divButton hoverBox"
                }
                onClick={() => {
                  nextHandler();
                }}
              >
                Next
              </a>
            </div>
            <Popup modal open={open}>
              <div className="header"> Please Wait </div>
              <div className="modal_content">
                We are currently calculating your score, please wait
              </div>
            </Popup>
          </form>
        </ul>
      </div>
    );
    function logInputs(event) {
      event.preventDefault();
      console.log(inputs);
      //newProfileReq(inputs, props.userKey, props.email);
    }
    //function submitInputs() {}
  }
};

export default ProfileForm;
